const AppData = {
  about: {
    firstName: "Sanjeet",
    lastName: "Kumar",
    mobileNo: "9445165233",
    email: "isanjeet09@gmail.com",
    workStarted: "08/01/2016",
    country: "India",
    location: "Bengaluru",
    linkedIn: "https://www.linkedin.com/in/isanjeet09",
    gitHub: "https://github.com/sanjeet05",
    whatsapp: "https://wa.me/919445165233",
  },
  experience: [
     {
      id: 108,
      name: "Mobius by Gaian",
      url: "https://www.mobiusdtaas.ai/",
      role: "Sr. Full Stack Engineer",
      start_date: new Date("06/26/2026"), // mm/dd/yyyy
      end_date: new Date(""), // mm/dd/yyyy
      is_present: true,
      line_1: [
        "Leading a small engineering team focused on <b>AI and backend engineering</b>, driving execution across product, architecture, and delivery.",
        "Developing <b>AI agents and agentic workflows</b> using Python and Go (Golang) for intelligent automation and decisioning systems.",
        "Working on <b>harness engineering</b> for building, testing, evaluating, and operating agentic systems in production.",
        "Designing and building <b>scalable, high-performance backend services</b> to power AI-driven experiences and internal platform capabilities.",
        "Driving <b>service scalability, reliability, observability, and production readiness</b> across distributed systems.",
        "Making architecture and technology decisions for <b>distributed systems and AI-powered services</b> with a focus on resilience and maintainability.",
        "Mentoring engineers and establishing <b>engineering best practices</b> across code quality, system design, and operational excellence.",
      ],
      line_2:
        "Stack Used: Python, Go, Docker, Kubernetes, AWS, Redis, PostgreSQL, gRPC, REST APIs, CI/CD, Git, Observability, Agentic Workflows.",
      tags: [
        "AI Agents",
        "Python",
        "Go",
        "Backend Engineering",
        "Distributed Systems",
        "Microservices",
        "Observability",
        "Agentic Workflows",
        "AWS",
        "System Design",
        "Mentoring",
      ],
    },
    {
      id: 107,
      name: "Alphastream.ai",
      url: "https://alphastream.ai/",
      role: "Sr. Full Stack Engineer",
      start_date: new Date("02/09/2026"), // mm/dd/yyyy
      end_date: new Date("06/19/2026"), // mm/dd/yyyy
      is_present: false,
      line_1: [
        "Built a <b>Private Credit Deal Lifecycle Platform</b> that served as the core system for end-to-end financial workflows and deal operations.",
        "Designed scalable backend services and modular frontend architecture for complex, high-throughput workflows across credit workflows and data-heavy product experiences.",
        "Contributed to system design decisions focused on <b>scalability, reliability, and extensibility</b> for a fast-growing financial platform.",
        "Engineered <b>RESTful APIs</b> for real-time deal data processing, reporting, and operational visibility across stakeholders.",
        "Implemented <b>event-driven workflows</b> to handle high-throughput financial data pipelines and improve platform responsiveness.",
        "Collaborated closely with product and business stakeholders to translate domain requirements into technical solutions for deal lifecycle management.",
        "Leveraged <b>Claude and ChatGPT</b> to accelerate development, improve code reviews, support architectural reasoning, and streamline documentation workflows.",
      ],
      line_2:
        "Stack Used: NodeJS, NestJS, ExpressJS, MySql, DynamoDB, Redis, ReactJS, NextJS, ES6, Docker, Webpack, NPM, Bootstrap, Html, CSS, Git, REST APIs, AI Tools.",
      tags: [
        "Private Credit",
        "Rest APIs",
        "Event-Driven",
        "NodeJS",
        "Docker",
        "System Design",
        "AWS",
        "AI Tools",
        "Product Collaboration",
      ],
    },
    {
      id: 106,
      name: "Twin Health",
      url: "https://ind.twinhealth.com/",
      role: "Sr. Full Stack Engineer",
      start_date: new Date("03/01/2021"), // mm/dd/yyyy
      end_date: new Date("10/30/2025"), // mm/dd/yyyy
      is_present: false,
      line_1: [
        "Developed and scaled a <b>Whole Body Digital Twin AI platform</b> focused on reversing Type 2 Diabetes and improving metabolic health outcomes.",
        "Led and mentored a team of engineers through code reviews, architectural guidance, and adoption of best practices.",
        "Collaborated with QA, Product, and cross-functional stakeholders to deliver <b>stable, on-time releases</b>.",
        "Designed and maintained a <b>microservices-based architecture</b> to support high availability and scalability.",
        "Built and managed <b>CI/CD pipelines</b> and containerized deployments using Docker and Kubernetes on AWS.",
        "Integrated <b>Razorpay</b> and <b>WhatsApp Business APIs</b>, improving payment success rates and user engagement.",
        "Optimized frontend performance, reducing page load times by <b>30%</b> and improving UI responsiveness.",
        "Used <b>AI Copilot</b> tools to accelerate development and improve code quality, refactoring, and test generation.",
      ],
      line_2:
        "Stack Used: NodeJS, ExpressJS, MySql, Redis, ReactJS, NextJS, Gatsby, Graphql, ES6, Docker, Webpack, NPM, Bootstrap, Html, CSS, Git.",
      tags: [
        "Rest APIs",
        "Graphql",
        "MicroService",
        "NodeJS",
        "Docker",
        "MERN Stack",
        "AWS",
        "CI/CD Pipeline",
        "Jira",
      ],
    },
    {
      id: 105,
      name: "SWRM Labs",
      url: "https://www.linkedin.com/company/swrmlabs/",
      role: "Full Stack Engineer",
      start_date: new Date("10/06/2019"),
      end_date: new Date("03/20/2021"),
      is_present: false,
      line_1: [
        "Developed and deployed <b>blockchain-powered decentralized applications (dApps)</b> on the Ethereum network.",
        "Built web interfaces for <b>Ethereum wallet integrations</b> using Ether.js.",
        "Integrated IPFS for decentralized file storage in product workflows.",
        "Implemented real-time communication features using Socket.io.",
        "Worked closely with blockchain architects to design <b>smart contract interaction layers</b>.",
        "Automated build and deployment processes through CI/CD pipelines.",
        "Improved system reliability, reducing production errors by <b>25%</b>.",
      ],
      line_2:
        "Stack Used: NodeJS, ExpressJS, PostgreSQL, MongoDB, Redis, ReactJS, ES6, D3.JS, Webpack, NPM, Material-UI, Bootstrap, Semantic-UI, Html, CSS, Git.",
      tags: [
        "Blockchain",
        "Web3.JS",
        "IPFS",
        "Docker",
        "Rest APIs",
        "MERN Stack",
        "MicroService",
        "AWS",
        "CI/CD Pipeline",
        "Jira",
      ],
    },
    {
      id: 104,
      name: "Qualitics",
      url: "https://www.linkedin.com/company/qualiticsusa/",
      role: "Full Stack Engineer",
      start_date: new Date("09/11/2018"),
      end_date: new Date("10/12/2019"),
      is_present: false,
      line_1: [
        "Developed backend services using Node.js, Python, and Flask for a <b>SaaS-based testing platform</b>.",
        "Designed and implemented a <b>scalable test execution engine</b> supporting parallel test runs.",
        "Built <b>multi-tenant architecture</b> with isolated data environments per client.",
        "Implemented <b>JWT-based authentication</b> and <b>role-based access control (RBAC)</b>.",
        "Integrated <b>PayPal payment gateway</b>, improving transaction reliability.",
        "Built interactive dashboards and reporting features using React.js and D3.js.",
        "Built 30+ reusable UI components, improving development speed by <b>20%</b>.",
      ],
      line_2:
        "Stack Used: Python, NodeJS, ExpressJS, MongoDB, PostgreSQL, Redis, ReactJS, Redux, ES6, Webpack, NPM, Material-UI, Bootstrap, Git, Nginx, Docker, AWS",
      tags: [
        "Rest APIs",
        "Python",
        "MongoDB",
        "ReactJS",
        "NodeJS",
        "AWS",
        "CI/CD Pipeline",
        "Jira",
      ],
    },
    {
      id: 103,
      name: "Zylotech - Acquired by Terminus",
      url: "https://www.linkedin.com/company/zylotech/",
      role: "Full Stack Developer",
      start_date: new Date("08/28/2017"),
      end_date: new Date("09/10/2018"),
      is_present: false,
      line_1: [
        "Built <b>customer AI products</b> end-to-end, from system architecture to production deployment, as part of the core engineering team.",
        "Developed REST APIs and integrated them with React.js frontends.",
        "Implemented <b>role-based access control (RBAC)</b> and multi-tenant authentication systems.",
        "Built <b>ElasticSearch-powered search and analytics</b> features for customer intelligence.",
        "Developed data visualization dashboards using D3.js for actionable customer insights.",
        "Integrated <b>AI-powered recommendation services</b> to drive personalized user experiences.",
      ],
      line_2:
        "Stack Used: MERN Stack Framework - Python, NodeJS, ExpressJS, ElasticSearch, MongoDB, PostgreSQL, Redis, ReactJS, Redux, ES6, D3.JS, Webpack, NPM, Material-UI, Semantic-UI, Bootstrap, Git, Nginx, Docker, AWS, Rest API.",
      tags: [
        "Rest APIs",
        "PostgreSQL",
        "ReactJS",
        "NodeJS",
        "ElasticSearch",
        "MERN Stack",
      ],
    },
    {
      id: 102,
      name: "SmartWinnr",
      url: "https://www.smartwinnr.com/",
      role: "Software Engineer",
      start_date: new Date("08/21/2016"),
      end_date: new Date("08/25/2017"),
      is_present: false,
      line_1: [
        "Built next-generation mobile and web platforms end-to-end, contributing across the full software development lifecycle as a core team member.",
        "Developed <b>hybrid mobile applications</b> using Ionic Framework and Cordova targeting Android.",
        "Built survey, quiz, and <b>gamification features</b> including leaderboards and badges.",
        "Implemented <b>real-time score tracking</b> and push notification systems for user engagement.",
        "Designed RESTful services and MongoDB data models to support scalable game mechanics.",
        "Developed data visualizations using D3.js to display team and individual performance metrics.",
      ],
      line_2:
        "Stack Used: Mean Stack Framework (NodeJS, ExpressJS, AngularJS, MongoDB), Redis, D3.JS, REST, NPM, Bower, Gulp, Bootstrap, AdminLte, BlurAdmin, Ionic Framework, Cordova, SqLite, Android SDK, Html, CSS, Git.",
      tags: [
        "Rest APIs",
        "MongoDB",
        "AngularJS",
        "NodeJS",
        "ExpressJS",
        "MEAN Stack",
        "JSON",
        "Hybrid App",
      ],
    },
    // {
    //   id: 101,
    //   name: "Sense Infinity Technology",
    //   url: "",
    //   role: "Full Stack Developer as Intern",
    //   start_date: new Date("05/10/2016"),
    //   end_date: new Date("08/08/2016"),
    //   is_present: false,
    //   line_1: `Worked on building a cool product, which is an e-commerce engine
    //   for a vertical space. as a part of the core team to architect
    //   and develop the web platform for all business and operational
    //   needs of the startup.`,
    //   line_2: `Stack Used: Laravel Framework(PHP), MySql, AngularJS, Bootstrap,
    //   Html, CSS, Git.`,
    //   tags: ["Intern", "Rest APIs", "Laravel", "AngularJS", "Git"]
    // }
  ],
  education: [
    {
      id: 102,
      level: "master",
      college: "Pondicherry University",
      course: "Master of Computer Application (MCA)",
      start_date: new Date("07/03/2013"),
      end_date: new Date("05/10/2016"),
    },
    {
      id: 101,
      level: "graduation",
      college: "Kuvempu University",
      course: "Bachelor of Science (B.Sc)",
      start_date: new Date("07/10/2008"),
      end_date: new Date("09/28/2012"),
    },
  ],
};

export default AppData;
